import { render, staticRenderFns } from "./IconSvgWav.vue?vue&type=template&id=6b92a46e&scoped=true&"
import script from "./IconSvgWav.vue?vue&type=script&lang=js&"
export * from "./IconSvgWav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b92a46e",
  null
  
)

export default component.exports